/* eslint-disable */
import React from "react";
import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { useStyles } from "./AlertStyles";
import CheckIcon from "@material-ui/icons/Check";
import Button from '@material-ui/core/Button';
import {Typography,Box} from '@material-ui/core'
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';

//Usage :
// Expects 3 props =>
// open: whether to show Toast message or not (true/false)
// closeHandler: function which will set state passed to open to false
// alertMessage: Toast Message

/* 
Note : to prevent closing of Snackbar on clickaway event, please add below condition in your closeHandler Function =>
const closeHandler = (event, reason) => {
  if(reason === 'clickaway){
    return;
  }
  //below your closing code 
}
*/

function ToastWithCancel(props) {
  const classes = useStyles();
  const { open, closeHandler, alertMessage, severity } = props;

  return (
    <Snackbar
      open={open}
      className={classes.snackBarStyle}
      autoHideDuration={8000}
      onClose={closeHandler}
    >
      <Alert
        onClose={closeHandler}
        severity={severity !== "" ? severity : ""}
        iconMapping={{
          success: (
            <CheckIcon className={classes.checkIconCustom} fontSize="inherit" />
          ),
          error:(
            <WarningOutlinedIcon className={classes.IconCustom} fontSize="inherit" />
         )
        }}
        className={`${
          severity === "success"
            ? classes.toastSuccessMessage
            : classes.toastMessage
        }`}
        sx={{
          width: "100%",
          fontFamily :'Work-Sans',
          fontWeight: "normal",
          fontSize: "16px",
          lineHeight: "20px",
          backgroundColor:'#F4FAF8',
          color: '#142A39',
          letterSpacing: "-0.2px",
        }}
      >  

           {alertMessage}

      </Alert>

    </Snackbar>
  );
}

export default ToastWithCancel;


// WEBPACK FOOTER //
// ./src/views/components/Modal/Alert.jsx